import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import HeaderAuth from '../components/home/HeaderAuth';
import Header from '../components/home/Header';
import ContactScreen from '../components/home/ContactScreen';

const ContactPage = () => {
  const { user } = useAuth();

  return (
    <div>
      <ContactScreen />
    </div>
  );
};

export default ContactPage;